<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <ul class="heading-ul mb-3">
          <li>
            <router-link to="/leads_history" class="vx-row">
              <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
              <h3>{{ $t("leads.label.leads_details") }}</h3>
            </router-link>
          </li>
        </ul>
      </div>
      <vx-card>
        <div class="vx-row">
          <div class="vx-col w-full pt-2">
            <ul class="horizontal-sm-btn flex float-right">
              <li>
                <div
                  class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                >
                  <vs-button
                    v-if="
                      leadInfo.status == 'Converted' &&
                      userType !== 'LEADGENERATOR'
                    "
                    color="success"
                    icon-pack="feather"
                    icon="icon-user"
                    class="truncate"
                    @click="handleSelected"
                    size="small"
                    >{{ $t("leads.label.customer_view") }}</vs-button
                  >
                  <vs-button
                    v-if="
                      leadInfo.status !== 'Converted' &&
                      userType !== 'LEADGENERATOR' &&
                      leadInfo.status !== 'Cancelled'
                    "
                    color="primary"
                    icon-pack="feather"
                    icon="icon-clock"
                    class="truncate"
                    @click="initFollowUp"
                    size="small"
                    >{{ $t("leads.label.follow_up") }}</vs-button
                  >
                  <vs-button
                    v-if="
                      leadInfo.status !== 'Converted' &&
                      userType == 'SALESMANAGER'
                    "
                    color="primary"
                    icon-pack="feather"
                    icon="icon-clock"
                    class="truncate"
                    @click="initAssignTo"
                    size="small"
                    >{{ $t("leads.label.assign_to") }}</vs-button
                  >
                  <vs-button
                    v-if="
                      leadInfo.status == 'New' &&
                      userType !== 'LEADGENERATOR' &&
                      userType !== 'SALESMANAGER'
                    "
                    color="primary"
                    icon-pack="feather"
                    class="truncate"
                    @click="initElevateProspect"
                    size="small"
                    >{{ $t("leads.label.elevate_prospect") }}</vs-button
                  >
                  <vs-button
                    v-if="
                      leadInfo.status == 'Prospect' &&
                      userType !== 'LEADGENERATOR' &&
                      userType !== 'SALESMANAGER' &&
                      !hasAcceptedQuote
                    "
                    color="primary"
                    icon-pack="feather"
                    class="truncate"
                    @click="createQuotePopup = true"
                    size="small"
                    >{{ $t("leads.label.generate_quotation") }}</vs-button
                  >
                  <vs-button
                    v-if="
                      leadInfo.status == 'Prospect' &&
                      userType !== 'LEADGENERATOR' &&
                      userType !== 'SALESMANAGER' &&
                      isActiveConvert
                    "
                    color="primary"
                    icon-pack="feather"
                    class="truncate"
                    @click="converToClient"
                    size="small"
                    >{{ $t("leads.label.convert_to_customer") }}</vs-button
                  >
                  <vs-button
                    v-if="leadInfo.status !== 'Cancelled'"
                    color="primary"
                    icon-pack="feather"
                    icon="icon-edit-2"
                    class="truncate"
                    @click="goToEditLead"
                    size="small"
                    >{{ $t("leads.label.edit") }}</vs-button
                  >
                  <vs-button
                    v-if="leadInfo.status !== 'Cancelled'"
                    color="primary"
                    icon-pack="feather"
                    icon="icon-x"
                    class="truncate"
                    size="small"
                    @click="initCancelProspect"
                    >{{ $t("leads.label.cancel") }}</vs-button
                  >
                </div>
              </li>
            </ul>
            <div class="table-heading pt-2" style="margin-bottom: 0px">
              {{ leadInfo.firstName }}
            </div>
          </div>
          <div class="vx-col w-full">
            <vs-table stripe :data="leadInfo" class="details-table">
              <template>
                <vs-tr>
                  <vs-td class="light">{{ $t("leads.label.name") }} </vs-td>
                  <vs-td class="black">{{ leadInfo.firstName }}</vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td class="light">{{ $t("leads.label.email_id") }} </vs-td>
                  <vs-td class="black">{{ leadInfo.email }}</vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td class="light"
                    >{{ $t("leads.label.phone_number") }}
                  </vs-td>
                  <vs-td class="black">{{ leadInfo.mobileNumber }}</vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td class="light">{{ $t("leads.label.address") }} </vs-td>
                  <vs-td class="black">{{ leadInfo.address }}</vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td class="light">{{ $t("leads.label.service") }} </vs-td>
                  <vs-td class="black">{{ leadInfo.arrOfStr[0] }}</vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td class="light">{{ $t("leads.label.note") }} </vs-td>
                  <vs-td class="black">{{ leadInfo.note }}</vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td class="light">{{ $t("leads.label.status") }} </vs-td>
                  <vs-td class="red" v-if="leadInfo.status === 'Cancelled'">{{
                    leadInfo.status
                  }}</vs-td>
                  <vs-td class="black" v-else>{{ leadInfo.status }}</vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
          <div class="vx-col w-full mt-4">
            <div class="table-heading">
              {{ $t("leads.label.history_data") }}
            </div>
            <vs-table :data="prospectHistory.prospectDetailData">
              <template slot="thead">
                <vs-th>{{ $t("leads.label.call_status") }}</vs-th>
                <vs-th>{{ $t("leads.label.next_call") }}</vs-th>
                <vs-th>{{ $t("leads.label.note") }}</vs-th>
                <vs-th>{{ $t("leads.label.user") }}</vs-th>
                <!-- <vs-th>{{ $t("leads.label.assign_to") }}</vs-th> -->
              </template>
              <template slot-scope="{ data }">
                <vs-tr
                  :key="index"
                  :data="prospectHistory.prospectDetailData"
                  v-for="(history, index) in data"
                >
                  <vs-td
                    :data="prospectHistory.prospectDetailData.callStatus"
                    >{{ history.callStatus }}</vs-td
                  >
                  <vs-td :data="prospectHistory.prospectDetailData.nextTime">{{
                    history.nextTime
                  }}</vs-td>
                  <vs-td :data="prospectHistory.prospectDetailData.notes">{{
                    history.notes
                  }}</vs-td>
                  <vs-td :data="prospectHistory.prospectDetailData.username">{{
                    history.username
                  }}</vs-td>
                  <!-- <vs-td
                    :data="prospectHistory.prospectDetailData.assignedTo"
                    >{{ history.assignedTo }}</vs-td
                  > -->
                </vs-tr>
              </template>
            </vs-table>
          </div>
          <div class="vx-col w-full mt-4">
            <div class="table-heading">{{ $t("leads.label.quotations") }}</div>
            <vs-table :data="quoteList">
              <template slot="thead">
                <vs-th>{{ $t("leads.label.quote_id") }}</vs-th>
                <vs-th>{{ $t("leads.label.quote_number") }}</vs-th>
                <vs-th>{{ $t("leads.label.lead_id") }}</vs-th>
                <vs-th>{{ $t("leads.label.status") }}</vs-th>
                <vs-th>{{ $t("leads.label.total_charge") }}</vs-th>
                <vs-th class="tHeadCenter">{{
                  $t("leads.label.action")
                }}</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr
                  :key="index"
                  :data="quote"
                  v-for="(quote, index) in data"
                >
                  <vs-td :data="quote.quoteId">{{ quote.quoteId }}</vs-td>
                  <vs-td :data="quote.quoteNumber">{{
                    quote.quoteNumber
                  }}</vs-td>
                  <vs-td :data="quote.leadId">{{ quote.leadId }}</vs-td>
                  <vs-td :data="quote.status">{{ quote.status }}</vs-td>
                  <vs-td :data="quote.totalCharge">{{
                    quote.totalCharge
                  }}</vs-td>
                  <vs-td class="whitespace-no-wrap">
                    <div class="container_img">
                      <feather-icon
                        v-if="quote.status !== 'accepted'"
                        icon="EditIcon"
                        title="edit"
                        class="truncate icon_row"
                        svgClasses="w-5 h-5 stroke-current orange_icon"
                        @click="getQuoteDetails(quote.leadId, quote.quoteId)"
                      />
                      <feather-icon
                        icon-pack="feather"
                        icon="DownloadIcon"
                        class="truncate text-warning icon_row"
                        size="small"
                        title="Download"
                        svgClasses="w-5 h-5"
                        @click="downloadStatement(quote.quoteId)"
                      />
                      <feather-icon
                        icon-pack="feather"
                        icon="MailIcon"
                        class="truncate icon_row"
                        size="small"
                        title="Mail"
                        svgClasses="w-5 h-5"
                        @click="sendMail(quote.quoteId)"
                      />
                      <feather-icon
                        icon-pack="feather"
                        icon="EyeIcon"
                        class="truncate icon_row"
                        size="small"
                        svgClasses="w-5 h-5 stroke-current text-primary"
                        title="View"
                        @click="viewQuote(quote.quoteId)"
                      />
                      <feather-icon
                        v-if="quote.status == 'Review'"
                        icon-pack="feather"
                        icon="CheckIcon"
                        class="truncate icon_row"
                        size="small"
                        title="Accepted"
                        svgClasses="w-5 h-5"
                        @click="updateQuoteStatus(quote.quoteId, 'accepted')"
                      />
                      <feather-icon
                        v-if="quote.status == 'Review'"
                        icon-pack="feather"
                        icon="XIcon"
                        class="truncate icon_row"
                        size="small"
                        svgClasses="w-5 h-5"
                        title="Rejected"
                        @click="updateQuoteStatus(quote.quoteId, 'rejected')"
                      />
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </vx-card>
      <div class="centerx">
        <vs-popup
          classContent="popup-example"
          :title="$t('leads.label.delete_service_plan')"
          :active.sync="removeServicePlan"
          class="popup-close small-popup"
        >
          <div class="center">
            <img src="@/assets/images/pages/delete.svg" />
            <div class="success-msg">Are you sure you want to delete?</div>
          </div>

          <div class="center">
            <span class="p-2">
              <vs-button type="border" @click="removeServicePlan = false">{{
                $t("leads.label.cancel")
              }}</vs-button></span
            >

            <span class="p-2">
              <vs-button @click="deleteServicePlan(removeInd)">{{
                $t("leads.label.confirm")
              }}</vs-button>
            </span>
          </div>
          <div style="height: 20px"></div>
        </vs-popup>
      </div>
      <div class="centerx">
        <vs-popup
          class="popup-close"
          :title="$t('leads.label.generate_quote')"
          classContent="popup-example"
          :active.sync="createQuotePopup"
        >
          <form>
            <div class="vx-row">
              <vx-card title card-border>
                <div class="vx-row ml-1">
                  {{ $t("leads.label.personal_details") }}
                </div>
                <div class="vx-row">
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <vs-input
                      :label="$t('leads.label.quote_number')"
                      class="w-full mb-2 font-semibold"
                      v-model="randomQuoteNo"
                      disabled
                    />
                  </div>
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <vs-input
                      :label="$t('leads.label.quote_status')"
                      class="w-full mb-2 font-semibold"
                      v-model="createQuoteStatus"
                      disabled
                    />
                  </div>
                </div>
                <div class="vx-row mt-4">
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <div class="dropdown-with-label">
                      <small class="date-label font-semibold">{{
                        $t("leads.label.quote_date")
                      }}</small>
                      <datepicker
                        placeholder="Select Date"
                        v-model="currentDate"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        class="min-w-200 w-full"
                        disabled
                      />
                    </div>
                  </div>
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <vs-input
                      :label="$t('leads.label.customer_id')"
                      class="w-full mb-2 font-semibold"
                      v-model="$route.params.id"
                      disabled
                    />
                  </div>
                </div>
                <div class="vx-row">
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <vs-input
                      :label="$t('leads.label.customer_name')"
                      class="w-full mb-2 font-semibold"
                      v-model="leadInfo.firstName"
                      disabled
                    />
                  </div>
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <vs-input
                      :label="$t('leads.label.address')"
                      class="w-full mb-2 font-semibold"
                      v-model="leadInfo.address"
                      disabled
                    />
                  </div>
                </div>
                <div class="vx-row mt-4">
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <vs-input
                      :label="$t('leads.label.street_area')"
                      class="w-full mb-2 font-semibold"
                      v-model="leadInfo.streetArea"
                      disabled
                    />
                  </div>
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <vs-input
                      :label="$t('leads.label.city_area')"
                      class="w-full mb-2 font-semibold starlabel"
                      v-model="leadInfo.cityDistrict"
                      disabled
                    />
                  </div>
                </div>
                <div class="vx-row mt-4">
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <vs-input
                      :label="$t('leads.label.district')"
                      class="w-full mb-2 font-semibold"
                      v-model="leadInfo.district"
                      disabled
                    />
                  </div>
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <vs-input
                      :label="$t('leads.label.state')"
                      class="w-full mb-2 font-semibold"
                      v-model="leadInfo.state"
                      disabled
                    />
                  </div>
                </div>
                <div class="vx-row mt-4">
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <vs-input
                      :label="$t('leads.label.country')"
                      class="w-full mb-2 font-semibold"
                      v-model="leadInfo.country"
                      disabled
                    />
                  </div>
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <vs-input
                      :label="$t('leads.label.zip_code')"
                      class="w-full mb-2 font-semibold"
                      v-model="leadInfo.zipCode"
                      disabled
                    />
                  </div>
                </div>
                <div class="vx-row mt-4">
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <vs-input
                      :label="$t('leads.label.total_charge')"
                      class="w-full mb-2 font-semibold"
                      v-model="totalCharge"
                      disabled
                    />
                  </div>
                </div>
                <div class="vx-row ml-1 mt-2">
                  {{ $t("leads.label.service_plan") }}
                </div>
                <div class="vx-row">
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <div class="dropdown-with-label">
                      <small class="date-label font-semibold">{{
                        $t("leads.label.service")
                      }}</small>
                      <v-select
                        label="serviceCode"
                        :options="clientServices.serviceData"
                        v-model="selectedService"
                        placeholder="--Select One--"
                        @input="selectService"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        class="min-w-200 w-full"
                      >
                      </v-select>
                    </div>
                  </div>
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <div class="dropdown-with-label">
                      <small class="date-label font-semibold">{{
                        $t("leads.label.plan")
                      }}</small>
                      <v-select
                        label="planDescription"
                        :options="quotePlanList"
                        v-model="selectedPlan"
                        placeholder="--Select One--"
                        @input="selectPlan"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        class="min-w-200 w-full"
                      >
                        <!-- <template v-slot:option="option">{{ option.item }}</template> -->
                      </v-select>
                    </div>
                  </div>
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <div class="dropdown-with-label">
                      <small class="date-label font-semibold">{{
                        $t("leads.label.frequency")
                      }}</small>
                      <v-select
                        label="chargeDescription"
                        :options="allChargeTypes"
                        v-model="selectedCharge"
                        placeholder="--Select One--"
                        @input="selectCharge"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        class="min-w-200 w-full"
                      >
                      </v-select>
                    </div>
                  </div>
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <vs-input
                      :label="$t('leads.label.recurring_charge')"
                      class="w-full mb-2 font-semibold"
                      v-model="createRecurringCharge"
                    />
                  </div>
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <vs-input
                      :label="$t('leads.label.one_time_charge')"
                      class="w-full mb-2 font-semibold"
                      v-model="createOneTimeCharge"
                    />
                  </div>
                  <div class="vx-col md:w-1/4 mt-4" style="margin: 0.5rem 0">
                    <vs-button @click="addPlanToQuote"
                      >{{ $t("leads.label.add") }}
                    </vs-button>
                  </div>
                  <div class="vx-col w-full mt-4">
                    <div class="table-heading">
                      {{ $t("leads.label.exists_service_plans") }}
                    </div>
                    <vs-table :data="createQuotePlanList">
                      <template slot="thead">
                        <vs-th>{{ $t("leads.label.service_code") }}</vs-th>
                        <vs-th>{{ $t("leads.label.plan_name") }}</vs-th>
                        <vs-th>{{ $t("leads.label.frequency") }}</vs-th>
                        <vs-th>{{ $t("leads.label.recurring_charge") }}</vs-th>
                        <vs-th>{{ $t("leads.label.one_time_charge") }}</vs-th>
                        <vs-th class="tHeadCenter">{{
                          $t("leads.label.action")
                        }}</vs-th>
                      </template>

                      <template slot-scope="{ data }">
                        <vs-tr
                          :key="index"
                          :data="createQuotePlanList"
                          v-for="(quotePlan, index) in data"
                        >
                          <vs-td :data="createQuotePlanList.serviceCode">{{
                            quotePlan.serviceId.serviceCode
                          }}</vs-td>
                          <vs-td :data="createQuotePlanList.planDescription">{{
                            quotePlan.planId.planDescription
                          }}</vs-td>
                          <vs-td
                            :data="createQuotePlanList.chargeDescription"
                            >{{ quotePlan.chargeCode.chargeDescription }}</vs-td
                          >
                          <vs-td :data="createQuotePlanList.recurringCharge">{{
                            quotePlan.planRecurirngCharge
                          }}</vs-td>
                          <vs-td
                            :data="createQuotePlanList.planonetimeCharge"
                            >{{ quotePlan.planonetimeCharge }}</vs-td
                          >
                          <vs-td class="whitespace-no-wrap">
                            <div class="container_img">
                              <button
                                @click="removeItem(index)"
                                class="bGNone border-none view_editTable_btn"
                              >
                                <feather-icon
                                  icon="TrashIcon"
                                  title="delete"
                                  svgClasses="w-5 h-5 text-danger stroke-current cursor"
                                  class="icon_row"
                                />
                              </button>
                              <!-- <feather-icon
                              icon="EditIcon"
                              title="edit"
                              svgClasses="w-5 h-5 text-danger stroke-current cursor"
                              @click.stop="
                                EditTemplate(broadcasters.templateId)
                              "
                              class="ml-2"
                            /> -->
                            </div>
                          </vs-td>
                        </vs-tr>
                      </template>
                    </vs-table>
                  </div>
                  <div class="vx-col w-full">
                    <div class="dropdown-with-label">
                      <small class="date-label font-semibold">{{
                        $t("leads.label.note")
                      }}</small>
                      <vs-textarea
                        class="w-full mb-2 font-semibold"
                        v-model="quoteCreateNote"
                      />
                    </div>
                  </div>
                </div>
              </vx-card>
            </div>
            <div class="vx-row center">
              <div class="vx-col w-full">
                <vs-button
                  color="primary"
                  type="border"
                  class="mb-2 footerButton-cancel"
                  @click="resetForm"
                  >{{ $t("leads.label.reset") }}</vs-button
                >
                <vs-button
                  class="mr-3 mb-2 footerButton-next"
                  @click.stop="createQuote"
                  >{{ $t("leads.label.submit") }}</vs-button
                >
              </div>
            </div>
          </form>
        </vs-popup>
      </div>

      <div class="centerx">
        <vs-popup
          class="popup-close"
          :title="$t('leads.label.edit_quote')"
          classContent="popup-example"
          :active.sync="editsJobsPopup"
        >
          <form>
            <div class="vx-row">
              <vx-card title card-border>
                <div class="vx-row ml-1">
                  {{ $t("leads.label.personal_details") }}
                </div>
                <div class="vx-row">
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <vs-input
                      :label="$t('leads.label.quote_number')"
                      class="w-full mb-2 font-semibold"
                      v-model="editQuoteNo"
                      disabled
                    />
                  </div>
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <vs-input
                      :label="$t('leads.label.quote_status')"
                      class="w-full mb-2 font-semibold"
                      v-model="editQuoteStatus"
                      disabled
                    />
                  </div>
                </div>
                <div class="vx-row mt-4">
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <div class="dropdown-with-label">
                      <small class="date-label font-semibold">{{
                        $t("leads.label.quote_date")
                      }}</small>
                      <datepicker
                        placeholder="Select Date"
                        v-model="editQuoteDate"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        class="min-w-200 w-full"
                        disabled
                      />
                    </div>
                  </div>
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <vs-input
                      :label="$t('leads.label.customer_id')"
                      class="w-full mb-2 font-semibold"
                      v-model="$route.params.id"
                      disabled
                    />
                  </div>
                </div>
                <div class="vx-row">
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <vs-input
                      :label="$t('leads.label.customer_name')"
                      class="w-full mb-2 font-semibold"
                      v-model="leadInfo.firstName"
                      disabled
                    />
                  </div>
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <vs-input
                      :label="$t('leads.label.address')"
                      class="w-full mb-2 font-semibold"
                      v-model="leadInfo.address"
                      disabled
                    />
                  </div>
                </div>
                <div class="vx-row mt-4">
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <vs-input
                      :label="$t('leads.label.street_area')"
                      class="w-full mb-2 font-semibold"
                      v-model="leadInfo.streetArea"
                      disabled
                    />
                  </div>
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <vs-input
                      :label="$t('leads.label.city_area')"
                      class="w-full mb-2 font-semibold starlabel"
                      v-model="leadInfo.cityDistrict"
                      disabled
                    />
                  </div>
                </div>
                <div class="vx-row mt-4">
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <vs-input
                      :label="$t('leads.label.district')"
                      class="w-full mb-2 font-semibold"
                      v-model="leadInfo.district"
                      disabled
                    />
                  </div>
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <vs-input
                      :label="$t('leads.label.state')"
                      class="w-full mb-2 font-semibold"
                      v-model="leadInfo.state"
                      disabled
                    />
                  </div>
                </div>
                <div class="vx-row mt-4">
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <vs-input
                      :label="$t('leads.label.country')"
                      class="w-full mb-2 font-semibold"
                      v-model="leadInfo.country"
                      disabled
                    />
                  </div>
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <vs-input
                      :label="$t('leads.label.zip_code')"
                      class="w-full mb-2 font-semibold"
                      v-model="leadInfo.zipCode"
                      disabled
                    />
                  </div>
                </div>
                <div class="vx-row mt-4">
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <vs-input
                      :label="$t('leads.label.total_charge')"
                      class="w-full mb-2 font-semibold"
                      v-model="editQuoteTotalCharge"
                      disabled
                    />
                  </div>
                </div>
                <div class="vx-row ml-1 mt-2">
                  {{ $t("leads.label.service_plan") }}
                </div>
                <div class="vx-row">
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <div class="dropdown-with-label">
                      <small class="date-label font-semibold">{{
                        $t("leads.label.service")
                      }}</small>
                      <v-select
                        label="serviceCode"
                        :options="clientServices.serviceData"
                        v-model="editSelectedService"
                        @input="selectService"
                        placeholder="--Select One--"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        class="min-w-200 w-full"
                      >
                      </v-select>
                    </div>
                  </div>
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <div class="dropdown-with-label">
                      <small class="date-label font-semibold">{{
                        $t("leads.label.plan")
                      }}</small>
                      <v-select
                        label="planDescription"
                        :options="quotePlanList"
                        v-model="editSelectedPlan"
                        placeholder="--Select One--"
                        @input="selectPlan"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        class="min-w-200 w-full"
                      >
                      </v-select>
                    </div>
                  </div>
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <div class="dropdown-with-label">
                      <small class="date-label font-semibold">{{
                        $t("leads.label.frequency")
                      }}</small>
                      <v-select
                        label="chargeDescription"
                        :options="allChargeTypes"
                        v-model="editSelectedCharge"
                        placeholder="--Select One--"
                        @input="
                          (val) =>
                            fetchPlanPricingInfo(
                              val.chargeCode,
                              this.editSelectedPlan.planId
                            )
                        "
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        class="min-w-200 w-full"
                      >
                      </v-select>
                    </div>
                  </div>
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <vs-input
                      :label="$t('leads.label.recurring_charge')"
                      class="w-full mb-2 font-semibold"
                      v-model="editRecurringCharge"
                    />
                  </div>
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <vs-input
                      :label="$t('leads.label.one_time_charge')"
                      class="w-full mb-2 font-semibold"
                      v-model="editOneTimeCharge"
                    />
                  </div>
                  <div class="vx-col md:w-1/4 mt-4" style="margin: 0.5rem 0">
                    <vs-button @click="addParameter1"
                      >{{ $t("leads.label.add") }}
                    </vs-button>
                  </div>
                  <div class="vx-col w-full mt-4">
                    <div class="table-heading">
                      {{ $t("leads.label.exists_service_plans") }}
                    </div>
                    <vs-table :data="editQuotePlanList">
                      <template slot="thead">
                        <vs-th>{{ $t("leads.label.service_code") }}</vs-th>
                        <vs-th>{{ $t("leads.label.plan_name") }}</vs-th>
                        <vs-th>{{ $t("leads.label.frequency") }}</vs-th>
                        <vs-th>{{ $t("leads.label.recurring_charge") }}</vs-th>
                        <vs-th>{{ $t("leads.label.one_time_charge") }}</vs-th>
                        <vs-th class="tHeadCenter">{{
                          $t("leads.label.action")
                        }}</vs-th>
                      </template>
                      <template slot-scope="{ data }">
                        <vs-tr
                          :key="index"
                          :data="editQuotePlanList"
                          v-for="(plan, index) in data"
                        >
                          <vs-td :data="editQuotePlanList.serviceCode">{{
                            plan.serviceCode
                          }}</vs-td>
                          <vs-td :data="editQuotePlanList.planDescription">{{
                            plan.planDescription
                          }}</vs-td>
                          <vs-td :data="editQuotePlanList.chargeDescription">{{
                            plan.chargeDescription
                          }}</vs-td>
                          <vs-td :data="editQuotePlanList.recurringCharge">{{
                            plan.recurringCharge
                          }}</vs-td>
                          <vs-td :data="editQuotePlanList.planonetimeCharge">{{
                            plan.planonetimeCharge
                          }}</vs-td>
                          <vs-td class="whitespace-no-wrap">
                            <div class="container_img">
                              <button
                                @click="removeItem(index)"
                                class="bGNone border-none view_editTable_btn"
                              >
                                <feather-icon
                                  icon="TrashIcon"
                                  title="delete"
                                  svgClasses="w-5 h-5 text-danger stroke-current cursor"
                                  class="icon_row"
                                />
                              </button>
                            </div>
                          </vs-td>
                        </vs-tr>
                      </template>
                    </vs-table>
                  </div>
                  <div class="vx-col w-full">
                    <div class="dropdown-with-label">
                      <small class="date-label font-semibold">{{
                        $t("leads.label.note")
                      }}</small>
                      <vs-textarea
                        class="w-full mb-2 font-semibold"
                        v-model="editQuoteNote"
                      />
                    </div>
                  </div>
                </div>
              </vx-card>
            </div>
            <div class="vx-row center">
              <div class="vx-col w-full">
                <vs-button
                  color="primary"
                  type="border"
                  class="mb-2 footerButton-cancel"
                  @click="resetForm"
                  >{{ $t("leads.label.reset") }}</vs-button
                >
                <vs-button
                  class="mr-3 mb-2 footerButton-next"
                  @click.stop="editQuote"
                  >{{ $t("leads.label.submit") }}</vs-button
                >
              </div>
            </div>
          </form>
        </vs-popup>
      </div>
      <div class="centerx">
        <vs-popup
          class="popup-close"
          :title="$t('leads.label.cancel_lead')"
          classContent="popup-example"
          :active.sync="deleteJobsPopup"
        >
          <form>
            <div class="mb-5">
              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full">
                  <div class="dropdown-with-label">
                    <small class="date-label font-semibold">{{
                      $t("leads.label.status_remark")
                    }}</small>
                    <v-select
                      label="statusRemark"
                      :options="cancelledProspect.statusRemarkData"
                      v-model="viewCancel.statusRemark"
                      placeholder="--Select One--"
                      :reduce="(obj) => obj.statusRemark"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="min-w-200 w-full"
                    >
                    </v-select>
                  </div>
                </div>
              </div>
            </div>
            <div class="center">
              <span class="ml-3 mr-4">
                <vs-button
                  type="border"
                  style="width: 190px; margin-top: 20px; margin-bottom: 10px"
                  @click="cancel"
                  >{{ $t("leads.label.cancel") }}</vs-button
                >
              </span>
              <span class="ml-1 mr-2">
                <vs-button style="width: 190px" @click="initDeleteProspects">{{
                  $t("leads.label.submit")
                }}</vs-button>
              </span>
            </div>
          </form>
        </vs-popup>
      </div>
      <div class="centerx">
        <vs-popup
          class="popup-close"
          :title="$t('leads.label.follow_up')"
          classContent="popup-example"
          :active.sync="followJobsPopup"
        >
          <form>
            <div class="mb-5">
              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full">
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("leads.label.call_status")
                      }}<span class="required"> *</span></small
                    >
                    <v-select
                      label="callStatus"
                      :reduce="(name) => name.statusId"
                      placeholder="--Select One--"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="min-w-200 w-full mb-2"
                      v-model="callStatus"
                      :options="followUpOptions.callStatusData"
                    >
                    </v-select>
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <div class="dropdown-with-label">
                    <small class="date-label">{{
                      $t("leads.label.next_call_date_time")
                    }}</small>
                    <flat-pickr
                      :config="configdateTimePicker"
                      class="w-full"
                      v-model="preferredCallingTime"
                    />
                  </div>
                </div>
              </div>
              <div class="vx-col md:w-full w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("leads.label.note")
                    }}<span class="required"> *</span></small
                  >
                  <vs-textarea class="w-full" v-model="notes" />
                </div>
              </div>
            </div>
            <div class="center">
              <span class="ml-3 mr-4">
                <vs-button
                  type="border"
                  style="width: 190px; margin-top: 20px; margin-bottom: 10px"
                  @click="resetFollowUp"
                  >{{ $t("leads.label.reset") }}</vs-button
                >
              </span>
              <span class="ml-1 mr-2">
                <vs-button style="width: 190px" @click="handleCreateFollowUp">{{
                  $t("leads.label.submit")
                }}</vs-button>
              </span>
            </div>
          </form>
          <validation-popup
            :errorMessage="errorMessage"
            :warningPopup="warningPopup"
            :warningText="warningText"
            @closeWarning="warningPopup = false"
          ></validation-popup>
        </vs-popup>
      </div>
      <div class="centerx">
        <vs-popup
          class="popup-close"
          :title="$t('leads.label.assign_to')"
          classContent="popup-example"
          :active.sync="assignToPopup"
        >
          <form>
            <div class="mb-5">
              <div style="width: 325px">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("leads.label.assign_to")
                    }}<span class="required"> *</span></small
                  >
                  <v-select
                    label="assignedTo"
                    :reduce="(name) => name.assignId"
                    placeholder="--Select One--"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                    v-model="assignedTo"
                    :options="followUpOptions.assignedToData"
                  >
                  </v-select>
                </div>
              </div>
              <div class="vx-col md:w-full w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("leads.label.note")
                    }}<span class="required"> *</span></small
                  >
                  <vs-textarea class="w-full" v-model="assignNote" />
                </div>
              </div>
            </div>
            <div class="center">
              <span class="ml-3 mr-4">
                <vs-button
                  type="border"
                  style="width: 190px; margin-top: 20px; margin-bottom: 10px"
                  @click="cancel"
                  >{{ $t("leads.label.cancel") }}</vs-button
                >
              </span>
              <span class="ml-1 mr-2">
                <vs-button style="width: 190px" @click="handleAssignTo">{{
                  $t("leads.label.save")
                }}</vs-button>
              </span>
            </div>
          </form>
          <validation-popup
            :errorMessage="errorMessage"
            :warningPopup="warningPopup"
            :warningText="warningText"
            @closeWarning="warningPopup = false"
          ></validation-popup>
        </vs-popup>
      </div>
    </div>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { mapState, mapGetters } from "vuex";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import { BUCKET_BASE_URL } from "@/http/index";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
export default {
  data() {
    return {
      customerId: "",
      removeServicePlan: false,
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      id: "",
      viewCancel: {
        statusRemark: "",
      },
      plan: {},
      createQuotePopup: false,
      editsJobsPopup: false,
      quotationJobsPopup: false,
      deleteJobsPopup: false,
      followJobsPopup: false,
      assignToPopup: false,
      assignNote: "",
      delId: 0,
      redirectToEdit: false,
      deletemessagesPopup: false,
      updateCraditPopup: false,
      jobsParameterPopup: false,
      servicePlanDetails: [],
      x: Math.floor(Math.random() * 10000),
      y: this.$route.params.id,
      configdateTimePicker: {
        enableTime: true,
        dateFormat: "Y-m-d H:i:s",
      },
      // create quote variables
      quoteCreateNote: "",
      randomQuoteNo:
        "QN" + this.$route.params.id + Math.floor(Math.random() * 10000),
      createQuoteStatus: "New",
      currentDate: moment().format("DD MMMM YYYY"),
      totalCharge: 0,
      selectedService: "",
      selectedPlan: "",
      selectedCharge: "",
      createRecurringCharge: 0,
      createOneTimeCharge: 0,
      createQuotePlanList: [],
      //edit quote variables
      editQuoteNo: "",
      editQuoteStatus: "",
      editQuoteDate: "",
      editQuoteTotalCharge: 0,
      editQuoteNote: "",
      editQuoteId: "",
      editSelectedService: "",
      editSelectedPlan: "",
      editSelectedCharge: "",
      editRecurringCharge: 0,
      editOneTimeCharge: 0,
      editQuotePlanList: [],
      // follow up variables
      assignedTo: "",
      callStatus: "",
      locale: "en",
      notes: "",
      preferredCallingTime: moment().format("YYYY-MM-DD HH:mm:ss"),
    };
  },
  components: {
    "v-select": vSelect,
    Datepicker,
    flatPickr,
  },
  watch: {
    followJobsPopup(newVal) {
      if (newVal) {
        document.body.classList.add("modal-open");
      } else {
        document.body.classList.remove("modal-open");
      }
    },
    planPriceData: {
    deep: true,
    immediate: true,
    handler(newVal) {
      if (Array.isArray(newVal) && newVal.length > 0) {
        this.createRecurringCharge = newVal[0].recurringCharge || 0;
        this.createOneTimeCharge = newVal[0].oneTimeCharge || 0;
      } else {
        this.createRecurringCharge = 0;
        this.createOneTimeCharge = 0;
      }
    }
  }
  },
  computed: {
    ...mapState({
      leadInfo: (state) => state.leads.leadInfo,
      prospectHistory: (state) => state.leads.prospectHistory,
      quoteList: (state) => state.leads.quoteList,
      clientServices: (state) => state.leads.clientServices,
      allChargeTypes: (state) => state.leads.allChargeTypes,
      quotePlanList: (state) => state.leads.quotePlanList,
      planPriceData: (state) => state.leads.planPriceData,
      quoteDetails: (state) => state.leads.quoteDetails,
      elavatedProspect: (state) => state.leads.elavatedProspect,
      status: (state) => state.leads.status,
      convertedClient: (state) => state.leads.convertedClient,
      cancelledProspect: (state) => state.leads.cancelledProspect,
      followUpOptions: (state) => state.leads.followUpOptions,
      customer: (state) => state.leads.customerId,
      user: (state) => state.auth.user,
    }),
    ...mapGetters({ userType: "auth/userType" }),
    hasAcceptedQuote() {
      return Array.isArray(this.quoteList) && this.quoteList.some(q => q.status && q.status.toLowerCase() === "accepted");
    },
    addedQuotePlanList() {
      let arr = [];
      if (this.createQuotePlanList.length) {
        this.createQuotePlanList.forEach((el) => {
          arr.push({
            ...el,
            locale: "en",
            chargeCode: el.chargeCode.chargeCode,
            planId: el.planId.id,
            serviceId: el.serviceId.id,
          });
        });
      }
      return arr;
    },
    isActiveConvert() {
      if (this.quoteList.length) {
        let hasAccepted = this.quoteList.filter(
          (el) => el.status == "accepted"
        );
        return hasAccepted.length ? true : false;
      } else return false;
    },
    editQuotePlanListPayload() {
      let arr = [];
      if (this.editQuotePlanList.length) {
        this.editQuotePlanList.forEach((el) => {
          arr.push({
            locale: "en",
            chargeCode: el.chargeCode,
            planId: el.planId,
            serviceId: el.serviceId,
            planRecurirngCharge: el.recurringCharge * 1,
            planonetimeCharge: el.planonetimeCharge * 1,
          });
        });
      }
      return arr;
    },
  },
  methods: {
    removeItem(i) {
      this.removeServicePlan = true;
      this.removeInd = i;
    },
    deleteServicePlan(id) {
      this.createQuotePlanList.splice(id, 1);
      this.editQuotePlanList.splice(id, 1);
      this.calCreateQuoteTotalCharge();
      this.removeServicePlan = false;
      this.$toasted.success("Service plan deleted successfully", {
        duration: 2000,
      });
    },
    viewQuote(quoteId) {
      this.$router.push({
        name: "Quote Details",
        params: { id: quoteId },
        query: { lead: this.$route.params.id },
      });
    },
    async sendMail(quoteId) {
      try {
        await this.$store.dispatch("leads/sendQuoteCreationMail", { quoteId });
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Mail Sending....",
          type: "success",
        });
      } catch (e) {
        this.$toasted.error(e.message, {
          duration: 2000,
        });
      }
    },
    async createQuote() {
      let payload = {
        quoteStatus: "Review",
        leadId: Number(this.$route.params.id),
        dateFormat: "dd MMMM yyyy",
        totalCharge: this.totalCharge,
        Notes: this.quoteCreateNote,
        quoteNo: this.randomQuoteNo,
        // servicePlanDetails = []
        locale: "en",
        quoteDate: moment().format("DD MMMM YYYY"),
      };
      try {
        await this.$store.dispatch("leads/createQuoteAction", {
          id: this.$route.params.id,
          data: {
            ...payload,
            servicePlanDetails: [...this.addedQuotePlanList],
          },
        });
        this.createQuotePopup = false;
        this.getAllQuotesInfo();
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Quotation Generated Successfully!",
          type: "success",
        });
      } catch (e) {
        this.$toasted.error(e.message, {
          duration: 2000,
        });
      }
    },
    async editQuote() {
      if (!this.leadInfo.status) {
        this.warningPopup = true;
        this.warningText = "Fill the required fields!";
      } else {
        let payload = {
          leadId: this.$route.params.id,
          quoteStatus: "New",
          dateFormat: "dd MMMM yyyy",
          quoteDate: this.editQuoteDate,
          totalCharge: this.editQuoteTotalCharge,
          Notes: this.editQuoteNote,
          quoteNo: this.editQuoteNo,
          servicePlanDetails: [...this.editQuotePlanListPayload],
          locale: "en",
        };
        try {
          await this.$store.dispatch("leads/editQuoteAction", {
            id: this.editQuoteId,
            data: payload,
          });
          this.editsJobsPopup = false;
          this.getAllQuotesInfo();
        } catch (e) {
          this.$toasted.error(e.message, {
            duration: 2000,
          });
        }
      }
    },
    async getQuoteDetails(id, QuoteId) {
      this.editsJobsPopup = true;
      try {
        await this.$store.dispatch("leads/fetchQuoteDetails", {
          id: id,
          QuoteId: QuoteId,
        });
        this.editQuotePlanList = this.quoteDetails;
        for (let test of this.editQuotePlanList) {
          test.chargeDescription = test.frequency;
        }
        for (let test of this.editQuotePlanList) {
          test.planonetimeCharge = test.oneTimeCharge;
        }
        for (let test of this.editQuotePlanList) {
          test.recurringCharge = test.recurringCharge;
        }
        this.editQuoteNo = this.quoteDetails[0].quoteNumber;
        this.editQuoteStatus = this.quoteDetails[0].status;
        const [year, month, day] = this.quoteDetails[0].quoteDate.split("-");
        this.editQuoteDate = `${day} ${moment()
          .month(month * 1 - 1)
          .format("MMM")} ${year}`;
        this.editQuoteTotalCharge = this.quoteDetails[0].totalCharge;
        this.editQuoteNote = this.quoteDetails[0].Notes;
        this.editSelectedService = this.clientServices.serviceData.find(
          (item) => item.serviceCode === this.quoteDetails[0].serviceCode
        );
        await this.selectService({ id: this.quoteDetails[0].serviceId });
        this.editSelectedPlan = this.quotePlanList.find(
          (item) =>
            item.planDescription === this.quoteDetails[0].planDescription
        );
        await this.selectPlan();
        this.editSelectedCharge = this.allChargeTypes.find(
          (item) => item.chargeDescription === this.quoteDetails[0].frequency
        );
        await this.fetchPlanPricingInfo(
          this.editSelectedCharge.chargeCode,
          this.editSelectedPlan.planId
        );
        this.editRecurringCharge = this.quoteDetails[0].recurringCharge;
        this.editOneTimeCharge = this.quoteDetails[0].oneTimeCharge;
        this.editQuoteId = QuoteId;
        this.calEditQuoteTotalCharge();
      } catch (e) {
        this.$toasted.error(e.message, {
          duration: 2000,
        });
      }
    },
    removeItem1(i) {
      this.editQuotePlanList.splice(i, 1);
      this.editQuotePlanList.forEach((el) => {
        this.editQuoteTotalCharge =
          this.editQuoteTotalCharge - el.planonetimeCharge - el.recurringCharge;
      });
      this.calEditQuoteTotalCharge();
    },
    addPlanToQuote() {
      let planInfo = {
        planRecurirngCharge: this.createRecurringCharge * 1,
        planonetimeCharge: this.createOneTimeCharge * 1,
        chargeCode: this.selectedCharge,
        planId: this.selectedPlan,
        serviceId: this.selectedService,
      };
      if (this.selectedService != "") {
        this.createQuotePlanList = [...this.createQuotePlanList, planInfo];
        this.createRecurringCharge = this.createOneTimeCharge = 0;
        this.selectedPlan = this.selectedCharge = this.selectedService = "";
        this.calCreateQuoteTotalCharge();
      }
    },
    addParameter1() {
      let planInfo = {
        recurringCharge: this.editRecurringCharge * 1,
        planonetimeCharge: this.editOneTimeCharge * 1,
        chargeCode: this.editSelectedCharge.chargeCode,
        planId: this.editSelectedPlan.planId,
        serviceId: this.editSelectedService.id,
        serviceCode: this.editSelectedService.serviceCode,
        chargeDescription: this.editSelectedCharge.chargeDescription,
        planDescription: this.editSelectedPlan.planDescription,
      };
      if (this.editSelectedService != "") {
        this.editQuotePlanList = [...this.editQuotePlanList, planInfo];
        this.editRecurringCharge = this.editOneTimeCharge = 0;
        this.editSelectedPlan =
          this.editSelectedCharge =
          this.editSelectedService =
            "";
      }
      this.calEditQuoteTotalCharge();
    },
    calEditQuoteTotalCharge() {
      this.editQuoteTotalCharge = 0;
      this.editQuotePlanList.forEach((el) => {
        this.editQuoteTotalCharge =
          this.editQuoteTotalCharge + el.planonetimeCharge + el.recurringCharge;
      });
    },
    calCreateQuoteTotalCharge() {
      this.totalCharge = this.createQuotePlanList.forEach((el) => {
        this.totalCharge =
          this.totalCharge + el.planRecurirngCharge + el.planonetimeCharge;
      });
    },

    editData() {
      this.$router.push({ path: `/chargeCode/edit/${this.$route.params.id}` });
    },

    goToEditLead() {
      this.$router.push({
        name: "Edit Lead",
        params: { id: this.$route.params.id },
      });
    },
    createQuotation() {
      this.$router.push(`/createQuotation/${this.$route.params.id}`);
    },

    async fetchLeadData() {
      try {
        await this.$store.dispatch(
          "leads/fetchLeadInfo",
          this.$route.params.id
        );
      } catch (e) {
        this.warningPopup = true;
        this.errors = e.message;
      }
    },
    async getProspectsHistory() {
      try {
        await this.$store.dispatch(
          "leads/fetchProospectHistory",
          this.$route.params.id
        );
      } catch (e) {
        this.warningPopup = true;
        this.errors = e.message;
      }
    },
    async getAllQuotesInfo() {
      try {
        await this.$store.dispatch(
          "leads/fetchAllQuotesInfo",
          this.$route.params.id
        );
      } catch (e) {
        this.warningPopup = true;
        this.errors = e.message;
      }
    },
    async getClientServiceTemplate() {
      try {
        await this.$store.dispatch(
          "leads/fetchClientServiceTemplate",
          this.$route.params.id
        );
        // this.clientServices = this.clientServices;
      } catch (e) {
        this.warningPopup = true;
        this.errors = e.message;
      }
    },
    async getChargeCode() {
      try {
        await this.$store.dispatch(
          "leads/fetchChargeCode",
          this.$route.params.id
        );
      } catch (e) {
        this.warningPopup = true;
        this.errors = e.message;
      }
    },
    async selectService(val) {
      await this.getQuotesPlans(val.id);
    },
    async getQuotesPlans(serviceId) {
      try {
        await this.$store.dispatch("leads/fetchQuotePlans", serviceId);
      } catch (e) {
        this.warningPopup = true;
        this.errors = e.message;
      }
    },
    async selectPlan() {
      await this.getChargeCode();
    },
    selectCharge(val) {
      this.fetchPlanPricingInfo(val.chargeCode, this.selectedPlan.id);
    },
    async fetchPlanPricingInfo(chargeCode, id) {
      try {
        await this.$store.dispatch("leads/fetchPlanPricing", {
          chargeCode: chargeCode,
          id,
        });
        if (this.planPriceData && this.planPriceData.length > 0) {
      this.createRecurringCharge = this.planPriceData[0].recurringCharge || 0;
      this.createOneTimeCharge = this.planPriceData[0].oneTimeCharge || 0;
    }
      } catch (e) {
        this.warningPopup = true;
        this.errors = e.message;
      }
    },

    async initElevateProspect() {
      if (!this.leadInfo.status) {
        this.warningPopup = true;
        this.warningText = "Fill the required fields!";
      } else {
        try {
          await this.$store.dispatch("leads/elevateProspectAction", {
            id: this.$route.params.id,
            data: this.elavatedProspect,
          });
          this.fetchLeadData();
          this.getProspectsHistory();
        } catch (e) {
          this.$toasted.error(e.message, {
            duration: 2000,
          });
        }
      }
    },

    async converToClient() {
      if (!this.leadInfo.status) {
        this.warningPopup = true;
        this.warningText = "Fill the required fields!";
      } else {
        try {
          await this.$store.dispatch("leads/handleConvertToClient", {
            id: this.$route.params.id,
            data: this.convertedClient,
          });
          await this.fetchLeadData();
          this.getProspectsHistory();
          if (this.leadInfo.statusRemark) {
            this.getCustomerId();
          }
        } catch (e) {
          this.$toasted.error(e.message, {
            duration: 2000,
          });
        }
      }
    },
    async updateQuoteStatus(quoteId, status) {
      try {
        await this.$store.dispatch("leads/acceptQuoteStatusAction", {
          id: this.$route.params.id,
          data: { quoteStatus: status, quoteId: quoteId },
        });
        this.quotationJobsPopup = false;
        this.getAllQuotesInfo();
      } catch (e) {
        this.$toasted.error(e.message, {
          duration: 2000,
        });
      }
    },
    async initCancelProspect() {
      this.deleteJobsPopup = true;
      try {
        await this.$store.dispatch(
          "leads/setProspectsCancel",
          this.$route.params.id
        );
        this.viewCancel = this.cancelledProspect;
      } catch (e) {
        this.warningPopup = true;
        this.errors = e.message;
      }
    },
    async initAssignTo() {
      try {
        await this.$store.dispatch(
          "leads/fetchFollowUpOptions",
          this.$route.params.id
        );
        this.assignToPopup = true;
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Assign Successfully!",
          type: "success",
        });
      } catch (e) {
        this.warningPopup = true;
        this.errors = e.message;
      }
    },
    resetForm() {
      this.createQuotePlanList = [];
    },
    async initFollowUp() {
      try {
        await this.$store.dispatch(
          "leads/fetchFollowUpOptions",
          this.$route.params.id
        );
        this.followJobsPopup = true;
      } catch (e) {
        this.warningPopup = true;
        this.errors = e.message;
      }
    },
    async initDeleteProspects() {
      if (!this.viewCancel.statusRemark) {
        this.warningPopup = true;
        this.warningText = "Fill the required fields!";
      } else {
        try {
          this.deleteJobsPopup = false;

          await this.$store.dispatch("leads/deleteProspectsAction", {
            id: this.$route.params.id,
            statusRemark: this.viewCancel.statusRemark,
          });
          this.fetchLeadData();
          this.getProspectsHistory();
        } catch (e) {
          this.$toasted.error(e.message, {
            duration: 2000,
          });
        }
      }
    },
    downloadStatement(id) {
      window.open(BUCKET_BASE_URL + `/quotes/${id}/print?tenantIdentifier=default`);
    },
    async handleAssignTo() {
      if (!this.assignedTo || !this.assignNote) {
        this.warningPopup = true;
        this.warningText = "Fill the required fields!";
        return;
      }
      try {
        let payload = {
          assignedTo: this.assignedTo,
          notes: this.assignNote,
        };
        await this.$store.dispatch("leads/assignToAction", {
          id: this.$route.params.id,
          data: payload,
        });
        this.assignedTo = "";
        this.assignNote = "";
        this.assignToPopup = false;
        this.fetchLeadData();
        this.getProspectsHistory();
      } catch (e) {
        this.assignToPopup = false;
        this.$toasted.error(e.message, {
          duration: 2000,
        });
      }
    },
    async handleCreateFollowUp() {
      if (!this.callStatus || !this.notes) {
        this.warningPopup = true;
        this.warningText = "Fill the required fields!";
        return;
      }
      try {
        let payload = {
          // assignedTo: this.assignedTo,
          callStatus: this.callStatus,
          locale: "en",
          notes: this.notes,
          preferredCallingTime: moment(this.preferredCallingTime).format(
            "YYYY-MM-DD HH:mm:ss"
          ),
        };
        await this.$store.dispatch("leads/createFollowUpAction", {
          id: this.$route.params.id,
          data: payload,
        });
        this.followJobsPopup = false;
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Follow Up Saved Successfully.",
          type: "success",
        });
        this.fetchLeadData();
        this.getProspectsHistory();
        this.resetFollowUpForm();
      } catch (e) {
        this.$toasted.error(e.message, {
          duration: 2000,
        });
      }
    },
    resetFollowUpForm() {
      this.callStatus = "";
      this.notes = "";
      this.preferredCallingTime = "";
    },
    async getCustomerId() {
      try {
        const res = await this.$store.dispatch(
          "leads/setCustomerId",
          this.leadInfo.statusRemark
        );
        this.customerId = res.data.id || res.data.accountNo.slice(-4);
      } catch (e) {
        // this.warningPopup = true;
        this.errors = e.message;
      }
    },
    handleSelected() {
      this.$router.push({
        name: "View Customer",
        params: { id: this.customerId },
      });
    },
    resetFollowUp() {
      (this.callStatus = ""),
        (this.preferredCallingTime = ""),
        (this.notes = "");
    },
    cancel() {
      this.deleteJobsPopup = false;
      this.followJobsPopup = false;
      this.assignToPopup = false;
    },
  },
  async mounted() {
    await this.fetchLeadData();
    this.getProspectsHistory();
    this.getAllQuotesInfo();
    this.getClientServiceTemplate();
    if (
      this.leadInfo.status == "Converted" &&
      this.userType !== "LEADGENERATOR"
    ) {
      this.getCustomerId();
    }
  },
};
</script>
<style>
.modal-open {
  overflow: hidden;
}
.red {
  color: red;
  font-weight: 600;
}
</style>
